module.exports = __webpack_public_path__ + "assets/2f5c787dfc77b3f8b017694912c35419.png";